module.exports = __webpack_public_path__ + "static/media/winning_1.99a83c1e.mp3";